import { Component, type ErrorInfo, type ReactNode } from "react";
import { Button } from "@/components/ui/button";

interface Props {
  children: ReactNode;
  resetKey: string;
}

interface State {
  hasError: boolean;
}

/** Shows a reload prompt instead of a blank screen when a page fails to load. */
export class RouteErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Route render failed:", error, info.componentStack);
  }

  componentDidUpdate(prev: Props) {
    if (this.state.hasError && prev.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 px-4 text-center">
        <h2 className="text-xl font-semibold text-foreground">{"\u0537\u057b\u0568 \u0579\u0570\u0561\u057b\u0578\u0572\u057e\u0565\u0581 \u0562\u0565\u057c\u0576\u0565\u056c"}</h2>
        <p className="text-muted-foreground">{"\u054d\u057f\u0578\u0582\u0563\u0565\u0584 \u056b\u0576\u057f\u0565\u0580\u0576\u0565\u057f \u056f\u0561\u057a\u0568 \u0587 \u0569\u0561\u0580\u0574\u0561\u0581\u0580\u0565\u0584 \u0567\u057b\u0568\u0589"}</p>
        <Button onClick={() => window.location.reload()}>{"\u0539\u0561\u0580\u0574\u0561\u0581\u0576\u0565\u056c"}</Button>
      </div>
    );
  }
}
